import { serviceRoles } from "config";
import { PIPELINE } from "constants/routes";
import { checkAccess } from "helpers/auth";
import PipelinePage from "./container/PipelinePage";

export default function getSettingsRoute(userAuth) {
  const { account, rhapsody } = serviceRoles;
  const requireAuth = {
    [rhapsody.name]: [account.roles.user],
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: PIPELINE,
    withSidebar: true,
    withAppBar: true,
    component: PipelinePage,
  };
}
